import {
    HttpClient,
    HttpEvent,
    HttpParams,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Article } from 'app/models/Article';
import { Page } from 'app/models/Page';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ArticleService {
    serveur_name = environment.serveur_name;
    host_name = environment.host_name;

    private baseURLArticle = this.host_name + '/api/media/type/article';
    private baseURLArticleLimit =
        this.host_name + '/api/media/type/Article/article';
    private baseURLArticlePaginate =
        this.host_name + '/api/media/paginate/article';
    private apiRecommendedArticle = this.host_name + '/api/media/recommended';
    private mediaURL = this.host_name + '/api/media';
    private auteurURL = this.host_name + '/api/media/auteur';
    private actifURL = this.host_name + '/api/media/actif';
    private uploadUrl = this.host_name + '/upload-service';
    private baseURLNews = this.host_name + '/api/media/type/news';
    private baseURLNewsLimit = this.host_name + '/api/media/type/News/news';
    private baseURLNewsPaginate = this.host_name + '/api/media/paginate/news';
    private baseURLInfographie =
        this.host_name + '/api/media/type/Article/infographie';
    private baseURLArticleEducatifsDebutant =
        this.host_name + '/api/media/type/Article/educatifDebutant';
    private baseURLArticleNouvellesDirigeants =
        this.host_name + '/api/media/type/Article/nouvellesDirigeants';
    token: string; 
     private articlesURL = this.host_name + '/api/media/articles';
    private newsURL = this.host_name + '/api/media/news';

    constructor(private httpClient: HttpClient) {}

    getArticles(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.baseURLArticle);
    }
    getArticlesPaginate(page: number, size: number): Observable<Page<Article>> {
        const params = new HttpParams({
            fromObject: {
                page: page.toString(),
                size: size.toString(),
            },
        });

        return this.httpClient.get<Page<Article>>(
            `${this.baseURLArticlePaginate}`,
            { params }
        );
    }

    getArticlesLimit(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.baseURLArticleLimit);
    }

    getArticle(id: string): Observable<Article> {
        return this.httpClient.get<Article>(`${this.mediaURL}/${id}`);
    }

    getRecommendedArticles(articleId: string): Observable<Article[]> {
        return this.httpClient.get<Article[]>(
            `${this.apiRecommendedArticle}/${articleId}`
        );
    }
    getNews(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.baseURLNews);
    }
    getNewsLimit(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.baseURLNewsLimit);
    }
    getNewsPaginate(page: number, size: number): Observable<Page<Article>> {
        const params = new HttpParams({
            fromObject: {
                page: page.toString(),
                size: size.toString(),
            },
        });

        return this.httpClient.get<Page<Article>>(
            `${this.baseURLNewsPaginate}`,
            {
                params,
            }
        );
    }
    getNewsById(id: string): Observable<Article> {
        return this.httpClient.get<Article>(`${this.mediaURL}/${id}`);
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(`${this.mediaURL}/media/${id}`);
    }

    updateArticle(article: Article): Observable<any> {
        return this.httpClient.put<Article>(
            `${this.mediaURL}/${article.id}`,
            article
        );
    }

    getArticleByAuteur(auteur: string): Observable<Article[]> {
        return this.httpClient.get<Article[]>(`${this.auteurURL}/${auteur}`);
    }
    getNewsByActif(actif: string): Observable<Article[]> {
        return this.httpClient.get<Article[]>(`${this.actifURL}/${actif}`);
    }

    enregistrer(article: Object): Observable<Object> {
        return this.httpClient.post<Article[]>(this.mediaURL, article);
    }

    enregistrerArticle(article: Object): Observable<Object> {
        return this.httpClient.post<Article>(this.articlesURL, article);
    }

    enregistrerNews(news: Object): Observable<Object> {
        return this.httpClient.post<Article>(this.newsURL, news);
    }
    upload(file: File): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
        formData.append('file', file);

        const req = new HttpRequest(
            'POST',
            `${this.uploadUrl}/upload/article`,
            formData,
            {
                reportProgress: false,
                responseType: 'json',
            }
        );
        return this.httpClient.request(req);
    }

    getFiles(): Observable<any> {
        return this.httpClient.get(`${this.uploadUrl}/files`);
    }
    getInfographie(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(this.baseURLInfographie);
    }
    getArticleEducatifsDebutant(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(
            this.baseURLArticleEducatifsDebutant
        );
    }
    getArticleNouvellesDirigeants(): Observable<Article[]> {
        return this.httpClient.get<Article[]>(
            this.baseURLArticleNouvellesDirigeants
        );
    }
}
